<template>
  <div>
    <section>
      <vue-markdown
        id="markdown-area"
        :source="$props.summary"
      />
    </section>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown-v2'

export default {
  name: "MarkdownSummary",
  components: {VueMarkdown},
  props: {
    summary: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
